import { Avatar, Dropdown, type MenuProps } from 'antd';
import type React from 'react';
import { IconLogout } from 'src/components/icons/icon-logout/icon-logout';
import { useUser, useUserActions } from 'src/hooks/data/users';

export const Profile: React.FC = () => {
  const user = useUser();
  const { signOut } = useUserActions();

  if (!user) {
    return null;
  }

  const items: MenuProps['items'] = [
    {
      label: (
        <div className="flex gap-x-8 items-center group-hover:font-medium">
          <IconLogout />
          Log Out
        </div>
      ),
      key: 'logout',
      className: 'group',
      onClick: () => {
        signOut();
      },
    },
  ];

  return (
    <Dropdown trigger={['click']} menu={{ items }} classNames={{ root: 'min-w-[102px]' }} placement="bottomLeft">
      <Avatar className="bg-[#12A88F] cursor-pointer">{user?.username?.[0].toUpperCase()}</Avatar>
    </Dropdown>
  );
};
